var search = "https://shopfront-cdn.tekoapis.com/static/dc6de02b661eb31c.svg";

export { search as default };
